import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/legal")({
  head: () => ({
    meta: [
      { title: "Aviso Legal y Privacidad — PRICO" },
      { name: "description", content: "Aviso legal, condiciones de uso y política de privacidad de PRICO." },
      { property: "og:title", content: "Aviso Legal y Privacidad — PRICO" },
      { property: "og:description", content: "Condiciones de uso y privacidad." },
      { property: "og:url", content: "/legal" },
    ],
    links: [{ rel: "canonical", href: "/legal" }],
  }),
  component: LegalPage,
});

function LegalPage() {
  return (
    <article className="container-prico py-20 max-w-3xl">
      <span className="chip">Legal</span>
      <h1 className="text-5xl font-black mt-4">Aviso Legal y Privacidad</h1>
      <p className="text-muted-foreground mt-2 text-sm">Última actualización: 15 de junio de 2026</p>

      <div className="prose-content mt-10 space-y-8 text-foreground/85">
        <Section title="1. Titularidad">
          <p>PRICO (en adelante, "PRICO" o "nosotros") es operado por PRICO S.A.S., con domicilio en Medellín, Colombia. Para cualquier consulta puedes escribirnos a <a className="text-primary" href="mailto:support@pricoapp.com">support@pricoapp.com</a>.</p>
        </Section>
        <Section title="2. Condiciones de uso">
          <p>El acceso y uso de este sitio web implica la aceptación plena de las presentes condiciones. PRICO se reserva el derecho de modificar el contenido en cualquier momento sin previo aviso.</p>
        </Section>
        <Section title="3. Protección de datos">
          <p>De conformidad con la Ley 1581 de 2012 y demás normativa aplicable, los datos personales recopilados a través de formularios o suscripciones son tratados con confidencialidad y usados exclusivamente para los fines informados.</p>
          <p>Los titulares de los datos podrán ejercer sus derechos de acceso, corrección, supresión y revocación escribiendo a <a className="text-primary" href="mailto:privacidad@prico.app">privacidad@prico.app</a>.</p>
        </Section>
        <Section title="4. Seguridad">
          <p>El sitio cuenta con certificado SSL (HTTPS) y aplica medidas técnicas y organizativas para proteger la información de los usuarios.</p>
        </Section>
        <Section title="5. Propiedad intelectual">
          <p>Todos los contenidos (logos, textos, gráficos, código) son propiedad de PRICO o de terceros con licencia. Queda prohibida su reproducción sin autorización previa.</p>
        </Section>
        <Section title="6. Legislación aplicable">
          <p>Estas condiciones se rigen por la legislación colombiana. Cualquier controversia será resuelta por los tribunales competentes de Medellín, Colombia.</p>
        </Section>
      </div>
    </article>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="text-2xl font-black">{title}</h2>
      <div className="mt-3 space-y-3 leading-relaxed">{children}</div>
    </section>
  );
}
